var PageSetup;
(function (PageSetup) {
    var textSize = 0;
    function showSpinner(item) {
        $(item).addClass("spinner");
    }
    function removeSpinner(item) {
        $(item).removeClass("spinner");
    }
    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=".concat(d.toUTCString());
        document.cookie = "".concat(cname, "=").concat(cvalue, "; ").concat(expires, "; secure=true");
    }
    function getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ')
                c = c.substring(1);
            if (c.indexOf(name) === 0)
                return c.substring(name.length, c.length);
        }
        return "";
    }
    function findCouncilLocation(position) {
        var address = $("#autocomplete-location-new").val();
        var path = "/Display/SearchRegion?lat=" + position.coords.latitude + "&lng=" + position.coords.longitude + "&address=" + address;
        $.ajax({
            url: path,
            type: "POST",
            success: function (response) {
                window.location.href = window.location.origin + '/' + response;
            }
        });
    }
    ;
    function findCouncilandLocation(position) {
        var geocoder = new google.maps.Geocoder();
        var latlng = {
            lat: parseFloat(position.coords.latitude),
            lng: parseFloat(position.coords.longitude),
        };
        geocoder.geocode({ location: latlng }, function (results, status) {
            if (status === "OK") {
                if (results[0]) {
                    //$("#autocomplete-location-new").val(results[0].formatted_address);
                }
                else {
                    window.alert("No results found");
                }
            }
            else {
                window.alert("Geocoder failed due to: " + status);
            }
        });
    }
    function handleNoGeolocation(errorMsg) {
        $("#foundCouncilClose").off("click");
        $("#foundCouncilClose").on("click", function () {
            $("#foundCouncil").slideUp('slow');
        });
        $("#foundCouncil .location-error").show();
        $("#foundCouncil .location-error .message-text").html(errorMsg);
        $("#foundCouncil .location-success").hide();
        $("#foundCouncil").slideDown('slow');
    }
    function isValidPassword(password) {
        var isValid = true;
        // password bigger than 6
        if (password.length > 6) {
            $("li.six-plus").addClass("complete");
        }
        else {
            $("li.six-plus").removeClass("complete");
            isValid = false;
        }
        if (password.match(/[a-z]/)) {
            $("li.lcase").addClass("complete");
        }
        else {
            $("li.lcase").removeClass("complete");
            isValid = false;
        }
        if (password.match(/[A-Z]/)) {
            $("li.ucase").addClass("complete");
        }
        else {
            $("li.ucase").removeClass("complete");
            isValid = false;
        }
        //if password has at least one number give 1 point
        if (password.match(/\d+/)) {
            $("li.numbers").addClass("complete");
        }
        else {
            $("li.numbers").removeClass("complete");
            isValid = false;
        }
        if (password.indexOf(' ') == -1) {
            $("li.nospaces").addClass("complete");
        }
        else {
            $("li.nospaces").removeClass("complete");
            isValid = false;
        }
        //if password has at least one special character give 1 point
        if (password.match(/.[!,@,#,$,%,^,&,*,=,?,_,~,-,.,(,)]/)) {
            $("li.punctuation").addClass("complete");
        }
        else {
            $("li.punctuation").removeClass("complete");
            isValid = false;
        }
        return isValid;
    }
    // platform sponsors
    function loadPlatformSponsors(affiliateId, councilRegionId, isCommunityInfo, councilLogo, councilUrl) {
        $.getJSON("/api/Sponsors/".concat(affiliateId, "/").concat(councilRegionId), function (data) {
            if (data.length !== 0 || councilUrl !== "") {
                var platformSponsor = [];
                var dataSponsor = [];
                for (var i = 0; i < data.length; i++) {
                    if (data[i].SponsorType === 0) {
                        platformSponsor.push(data[i]);
                    }
                    else {
                        dataSponsor.push(data[i]);
                    }
                }
                if (isCommunityInfo) {
                    if (councilUrl !== "") {
                        platformSponsor.push({
                            ImageBaseUrl: councilLogo,
                            Url: councilUrl
                        });
                    }
                }
                // Platform Sponsor //
                if (platformSponsor.length > 0) {
                    $("#sponsorsDiv").toggleClass('hidden');
                    $("#lstPlatformSponsors").parent().show();
                    var template = $("#platformSponsorsTemplate").render(platformSponsor);
                    var $template = $("<div/>").html(template);
                    $(".nofollow", $template).removeAttr("rel");
                    template = $template.html();
                    $("#lstPlatformSponsors").html(template);
                    $("#lstPlatformSponsors").not('.slick-initialized').slick({
                        slidesToShow: 2,
                        slide: $("#lstPlatformSponsors").attr("data-slick-slideElement"),
                        autoplay: true,
                        variableWidth: true,
                        infinite: true,
                        centreMode: true
                    });
                    $("#sponsorsDiv img").on("mouseover", function () {
                        var hoverVal = '';
                        if ($(this).data("image-hover") === "") {
                            hoverVal = $(this).data("image-base");
                        }
                        else {
                            hoverVal = $(this).data("image-hover");
                        }
                        $(this).attr("src", hoverVal);
                    });
                    $("#sponsorsDiv img").on("mouseout", function () {
                        var baseVal = $(this).data("image-base");
                        $(this).attr("src", baseVal);
                    });
                }
                // Data Sponsor //
                if (dataSponsor.length > 0) {
                    $("#dataSponsorsDiv").toggleClass('hidden');
                    $("#lstDataSponsors").parent().show();
                    var template2 = $("#dataSponsorsTemplate").render(dataSponsor);
                    var $template2 = $("<div/>").html(template2);
                    $(".nofollow", $template2).removeAttr("rel");
                    template2 = $template2.html();
                    $("#lstDataSponsors").html(template2);
                    $("#lstDataSponsors").not('.slick-initialized').slick({
                        slidesToShow: $("#lstDataSponsors").attr("data-slick-slidesToShow"),
                        slide: $("#lstDataSponsors").attr("data-slick-slideElement"),
                        autoplay: true
                    });
                    $("#dataSponsorsDiv img").on("mouseover", function () {
                        var hoverVal = '';
                        if ($(this).data("image-hover") === "") {
                            hoverVal = $(this).data("image-base");
                        }
                        else {
                            hoverVal = $(this).data("image-hover");
                        }
                        $(this).attr("src", hoverVal);
                    });
                    $("#dataSponsorsDiv img").on("mouseout", function () {
                        var baseVal = $(this).data("image-base");
                        $(this).attr("src", baseVal);
                    });
                }
            }
        });
    }
    // platform sponsors end
    function Init() {
        // Placeholder support for IE
        $('input').placeholder();
        var previouslyFocused;
        $(".modal").on("show.bs.modal", function () {
            previouslyFocused = document.activeElement;
        });
        // Make first input field in a modal get focus
        $(".modal").on("shown.bs.modal", function () {
            var field = $(this).find("input[type=text],textarea,select").filter(":visible:enabled:not([readonly]):first");
            if (field != null) {
                field.focus();
            }
            $(this).attr("aria-hidden", "false");
            // Handle behaviour when user _could_ be tabbing out of modal... confusing for screen reader users
            var inputs = $("select, input, textarea, button, a, [tabinput='0']", this).filter(":visible:not([disabled]):not([readonly])");
            var firstInput = inputs.first();
            var lastInput = inputs.last();
            lastInput.on("keydown", function (e) {
                if ((e.which === 9 && !e.shiftKey)) {
                    e.preventDefault();
                    firstInput.focus();
                }
            });
            firstInput.on("keydown", function (e) {
                if ((e.which === 9 && e.shiftKey)) {
                    e.preventDefault();
                    lastInput.focus();
                }
            });
        });
        $(".modal").on("hidden.bs.modal", function () {
            $(this).attr("aria-hidden", "true");
            if (previouslyFocused) {
                $(previouslyFocused).focus();
            }
        });
        $("#popupModal").modal({ backdrop: 'static', keyboard: false, show: true });
        // Initialise apsects of the page
        InitTooltips();
        InitSearchButton();
        InitNavigation();
        InitSliders();
        InitPullout();
        InitTextSizeChange();
        ObfuscateEmails();
        InitMap();
        InitAutoComplete();
        InitCouncilSearch();
        InitOneClick();
        // Tooltips for all elements with a non-empty title attribute
        Common.SetupTooltipsStyling();
    }
    PageSetup.Init = Init;
    function InitEventRegisterValidation() {
        $.validator.setDefaults({
            errorClass: "has-error",
            validClass: "has-success",
            highlight: function (element, errorClass, validClass) {
                if (element.type === "radio") {
                    this.findByName(element.name).addClass(errorClass).removeClass(validClass);
                }
                else {
                    $(element).closest('.form-row').removeClass(validClass).addClass(errorClass);
                    $(element).closest('.form-row').find('i.glyphicon.form-control-feedback').remove();
                    $(element).closest('.form-row').append('<i class="glyphicon glyphicon-remove form-control-feedback"></i>');
                }
            },
            unhighlight: function (element, errorClass, validClass) {
                if (element.type === "radio") {
                    this.findByName(element.name).removeClass(errorClass).addClass(validClass);
                }
                else {
                    $(element).closest('.form-row').removeClass(errorClass).addClass(validClass);
                    $(element).closest('.form-row').find('i.glyphicon.form-control-feedback').remove();
                    $(element).closest('.form-row').append('<i class="glyphicon glyphicon-ok form-control-feedback"></i>');
                }
            }
        });
        //$.validator.addMethod(
        //    "emailAvailable",
        //    function (value, element) {
        //        var checkUrl = "/api/Users/IsEmailAvailable";
        //        return $.validator.methods["remote"].call(this, value, element, { url: checkUrl });
        //    }, "Email address already in use"
        //);
        $.validator.addMethod("usernameAvailable", function (value, element) {
            var checkUrl = "/api/Users/IsUsernameAvailable";
            return $.validator.methods["remote"].call(this, value, element, { url: checkUrl });
        }, "User name not available");
        $.validator.addMethod("mobileAvailable", function (value, element) {
            var checkUrl = "/api/Users/IsMobileAvailable";
            return $.validator.methods["remote"].call(this, value, element, { url: checkUrl });
        }, "That Mobile number is already in use");
        //$.validator.addMethod(
        //    "emailAvailable",
        //    function (value, element) {
        //        var checkUrl = "/api/Users/IsEmailAvailable";
        //        return $.validator.methods["remote"].call(this, value, element, { url: checkUrl });
        //    }, "Email address already in use"
        //);
        $.validator.addMethod("mcdUsername", function (value, element) {
            var re = new RegExp(/^[A-Za-z0-9_@\.\-]{5,}$/);
            return this.optional(element) || value.match(re);
        }, "Please enter a valid username.");
        $.validator.addMethod("ausPhone", function (value, element) {
            var re = new RegExp(/^04\d{8}\s*$|^(04\d{2}\s\d{3}\s\d{3})\s*$|^(\d{2}\s*\d{4}\s*\d{4})\s*$|^(\(*\d{2}\)\s*\d{4}\s*\d{4})\s*$|^13(\s*\d{2}){2,3}$|^(1300|1800)\s*\d{3}\s*\d{3}\s*$/);
            return this.optional(element) || value.match(re);
        }, "Please enter a valid Australian phone number.");
        $.validator.addMethod("ausMobile", function (value, element) {
            var trimmedValue = value.replace(/[^\d\+]/gi, '');
            var re = new RegExp(/^\({0,1}((0|\+61)(4)){0,1}\){0,1}(\ |-){0,1}[0-9]{2}(\ |-){0,1}[0-9]{2}(\ |-){0,1}[0-9]{1}(\ |-){0,1}[0-9]{3}$/);
            return this.optional(element) || trimmedValue.match(re);
        }, "Please enter a valid Australian mobile number.");
        $.validator.addMethod("ausDate", function (value) {
            return Date.parseExact(value, "d/M/yyyy");
        }, "Please enter a value date. eg. d/M/yyyy");
        $.validator.addMethod("regex", function (value, element, regexp) {
            var re = new RegExp(regexp);
            return this.optional(element) || value.match(re);
        }, "Please check your input.");
        $.validator.addMethod("simpleUrl", function (value, element) {
            // Customised version of the url test to make the prefix optional
            return this.optional(element) || /^((https?|ftp):\/\/)?(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(value);
        }, "Please enter a valid URL.");
        $.validator.addMethod("mcdEmail", function (value, element) {
            var re = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
            return this.optional(element) || value.match(re);
        }, "Please enter a valid email address.");
        $(".ausMobile").on("blur", function () {
            var mobileRe = new RegExp(/^04\d{8}$/);
            var trimValue = $(this).val();
            trimValue = trimValue.replace(/[^\d\+]/gi, '');
            if (trimValue.startsWith("+61")) {
                trimValue = trimValue.replace("+61", "0");
            }
            if (trimValue.match(mobileRe)) {
                var newValue = trimValue.substr(0, 4) + " " + trimValue.substr(4, 3) + " " + trimValue.substr(7, 3);
                $(this).val(newValue);
            }
        });
    }
    PageSetup.InitEventRegisterValidation = InitEventRegisterValidation;
    function InitValidation() {
        $.validator.setDefaults({
            errorClass: "has-error",
            validClass: "has-success",
            highlight: function (element, errorClass, validClass) {
                if (element.type === "radio") {
                    this.findByName(element.name).addClass(errorClass).removeClass(validClass);
                }
                else {
                    $(element).closest('.form-row').removeClass(validClass).addClass(errorClass);
                    $(element).closest('.form-row').find('i.glyphicon.form-control-feedback').remove();
                    $(element).closest('.form-row').append('<i class="glyphicon glyphicon-remove form-control-feedback"></i>');
                }
            },
            unhighlight: function (element, errorClass, validClass) {
                if (element.type === "radio") {
                    this.findByName(element.name).removeClass(errorClass).addClass(validClass);
                }
                else {
                    $(element).closest('.form-row').removeClass(errorClass).addClass(validClass);
                    $(element).closest('.form-row').find('i.glyphicon.form-control-feedback').remove();
                    $(element).closest('.form-row').append('<i class="glyphicon glyphicon-ok form-control-feedback"></i>');
                }
            }
        });
        $.validator.addMethod("emailAvailable", function (value, element) {
            var checkUrl = "/api/Users/IsEmailAvailable";
            return $.validator.methods["remote"].call(this, value, element, { url: checkUrl });
        }, "Email address already in use");
        $.validator.addMethod("usernameAvailable", function (value, element) {
            var checkUrl = "/api/Users/IsUsernameAvailable";
            return $.validator.methods["remote"].call(this, value, element, { url: checkUrl });
        }, "User name not available");
        $.validator.addMethod("mobileAvailable", function (value, element) {
            var checkUrl = "/api/Users/IsMobileAvailable";
            return $.validator.methods["remote"].call(this, value, element, { url: checkUrl });
        }, "That Mobile number is already in use");
        $.validator.addMethod("emailAvailable", function (value, element) {
            var checkUrl = "/api/Users/IsEmailAvailable";
            return $.validator.methods["remote"].call(this, value, element, { url: checkUrl });
        }, "Email address already in use");
        $.validator.addMethod("mcdUsername", function (value, element) {
            var re = new RegExp(/^[A-Za-z0-9_@\.\-]{5,}$/);
            return this.optional(element) || value.match(re);
        }, "Please enter a valid username.");
        $.validator.addMethod("ausPhone", function (value, element) {
            var re = new RegExp(/^04\d{8}\s*$|^(04\d{2}\s\d{3}\s\d{3})\s*$|^(\d{2}\s*\d{4}\s*\d{4})\s*$|^(\(*\d{2}\)\s*\d{4}\s*\d{4})\s*$|^13(\s*\d{2}){2,3}$|^(1300|1800)\s*\d{3}\s*\d{3}\s*$/);
            return this.optional(element) || value.match(re);
        }, "Please enter a valid Australian phone number.");
        $.validator.addMethod("ausMobile", function (value, element) {
            var trimmedValue = value.replace(/[^\d\+]/gi, '');
            var re = new RegExp(/^\({0,1}((0|\+61)(4)){0,1}\){0,1}(\ |-){0,1}[0-9]{2}(\ |-){0,1}[0-9]{2}(\ |-){0,1}[0-9]{1}(\ |-){0,1}[0-9]{3}$/);
            return this.optional(element) || trimmedValue.match(re);
        }, "Please enter a valid Australian mobile number.");
        $.validator.addMethod("ausDate", function (value) {
            return Date.parseExact(value, "d/M/yyyy");
        }, "Please enter a value date. eg. d/M/yyyy");
        $.validator.addMethod("regex", function (value, element, regexp) {
            var re = new RegExp(regexp);
            return this.optional(element) || value.match(re);
        }, "Please check your input.");
        $.validator.addMethod("simpleUrl", function (value, element) {
            // Customised version of the url test to make the prefix optional
            return this.optional(element) || /^((https?|ftp):\/\/)?(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(value);
        }, "Please enter a valid URL.");
        $.validator.addMethod("mcdEmail", function (value, element) {
            var re = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
            return this.optional(element) || value.match(re);
        }, "Please enter a valid email address.");
        $(".ausMobile").on("blur", function () {
            var mobileRe = new RegExp(/^04\d{8}$/);
            var trimValue = $(this).val();
            trimValue = trimValue.replace(/[^\d\+]/gi, '');
            if (trimValue.startsWith("+61")) {
                trimValue = trimValue.replace("+61", "0");
            }
            if (trimValue.match(mobileRe)) {
                var newValue = trimValue.substr(0, 4) + " " + trimValue.substr(4, 3) + " " + trimValue.substr(7, 3);
                $(this).val(newValue);
            }
        });
    }
    PageSetup.InitValidation = InitValidation;
    function InitTooltips() {
        // Create tooltips
        $('[data-toggle="tooltip"]').each(function () {
            $(this).tooltip({
                trigger: "hover focus"
            });
            $(this).on("click touchend", function (e) {
                e.preventDefault();
            });
        });
    }
    PageSetup.InitTooltips = InitTooltips;
    function InitSearchButton(locationId, locationName) {
        if (locationId === void 0) { locationId = 0; }
        if (locationName === void 0) { locationName = ""; }
        $("#hfLocationId").val(locationId);
        if (document.getElementById('autocomplete-location-new')) {
            McdMaps.setDefaultLocation(false, true);
            McdMaps.getResults('#autocomplete-location-new');
        }
        $("#btn-search").off('click touchend');
        $("#btn-search").on('click touchend', function (e) {
            var _a;
            e.preventDefault();
            var organisationId = parseInt($("#hfOrganisationId").val()) || 0;
            var outletId = parseInt($("#hfOutletId").val()) || 0;
            var osrId = parseInt($("#hfOSRId").val()) || 0;
            var categoryGroupId = parseInt($("#hfCategoryGroupId").val()) || 0;
            var categoryId = parseInt($("#hfCategoryId").val()) || 0;
            var locationId = parseInt($("#hfLocationId").val()) || 0;
            var rad = parseInt($(".ddl-radius").val()) || 50;
            // For tags, show the selected keyword (if relevant) in the search box, but feed through the
            // actual tag name into the search
            var txt = $("#hfTagName").val() || $('#autocomplete-category').val();
            var where = (_a = $('#autocomplete-location-new').val()) !== null && _a !== void 0 ? _a : "";
            var councilId = parseInt($("#hfCouncilId").val()) || 0;
            var state = $("#State_Code").val() || '';
            var shiftCategoryId = parseInt($("#hfShiftCategoryId").val()) || 0;
            if ($('#autocomplete-location-new').val() == "") {
                state = "";
            }
            var url;
            if (organisationId > 0 || outletId > 0 || osrId > 0) {
                var id;
                var criteria;
                if (organisationId > 0) {
                    id = organisationId;
                    criteria = "isOrganisation";
                }
                else if (outletId > 0) {
                    id = outletId;
                    criteria = "isLocation";
                }
                else {
                    id = osrId;
                    criteria = "isListing";
                }
                url = "/Search/Redirect?id=" + id +
                    "&" + criteria + "=true" +
                    (locationId > 0 ? "&locationId=" + locationId : "") +
                    (councilId > 0 ? "&councilRegionId=" + councilId : "");
            }
            else {
                var queryString = window.location.search;
                var urlParams = new URLSearchParams(queryString);
                var isFromTile = urlParams.get('isFromTile');
                if (isFromTile)
                    where = where.split(" ")[0];
                url = "/Search/Directory?what=" + encodeURIComponent(txt) +
                    "&where=" + encodeURIComponent(where) +
                    "&service=" + categoryId +
                    "&category=" + categoryGroupId +
                    (locationId > 0 ? "&location=".concat(locationId) : "") +
                    "&radius=" + rad +
                    "&council=" + councilId +
                    "&state=" + state +
                    "&shiftCategory=" + shiftCategoryId;
                if (isFromTile) {
                    url = url + "&isFromTile=" + isFromTile;
                }
            }
            if (typeof userSearchModel !== 'undefined') {
                saveUserSearch(userSearchModel);
            }
            if (!isFromTile) {
                Common.RequestLocation(url, "&location=", "&where=", locationId, where);
            }
            else {
                window.location.href = url;
            }
        });
        function saveUserSearch(userSearch) {
            if (!userSearch) {
                console.error("Invalid user search data provided.");
                return; // Exit the function if userSearch is null or undefined
            }
            $.ajax({
                url: "/StoreSearchedModelInSession",
                type: "POST",
                contentType: "application/json",
                dataType: "json",
                data: JSON.stringify(userSearch),
                error: function (result) {
                    // Display a general error message to the user
                    alert("Sorry, there was a problem processing your request. Please try again later.");
                    console.error("AJAX error in request: " + result.responseText);
                },
                success: function (result) {
                },
            });
        }
        $(document).ready(function () {
            $('#autocomplete-category').keypress(function (e) {
                if (e.keyCode == 13) {
                    $('#btn-search').click();
                }
            });
        });
        $(".advanced-search-btn").off('click touchend');
        $(".advanced-search-btn").on('click touchend', function (e) {
            e.preventDefault();
            var councilId = parseInt($("#hfCouncilId").val()) || 0;
            var state = $("#State_Code").val() || "";
            var tempUrl = '/Search/Advanced' + location.search;
            if (councilId > 0) {
                if (tempUrl.indexOf('?') < 0) {
                    tempUrl += '?council=' + councilId;
                }
                else {
                    tempUrl += '&council=' + councilId;
                }
            }
            if (state !== '') {
                if (tempUrl.indexOf('?') < 0) {
                    tempUrl += '?state=' + state;
                }
                else {
                    tempUrl += '&state=' + state;
                }
            }
            window.location.href = tempUrl;
        });
    }
    PageSetup.InitSearchButton = InitSearchButton;
    function IsValidPassword(password) {
        return isValidPassword(password);
    }
    PageSetup.IsValidPassword = IsValidPassword;
    function InitNavigation() {
        // Bind toggle events for navigation pullouts
        $(".menu-button").on("click touchend", function () {
            $(".wrapper:eq(0)").toggleClass("reveal-right");
            document.activeElement.blur();
            if ($("#m_google_translate_element").is(":visible")) {
                if ($(".wrapper").hasClass("reveal-right")) {
                    $("#google_translate_element").appendTo($("#m_google_translate_element"));
                }
                else {
                    $("#google_translate_element").appendTo($("#googleTrans"));
                }
            }
            return false;
        });
        // Close the navigation pullouts under certain conditions
        // Track when the touch move event is detected
        var touchMoved = false;
        $(document).on("touchmove", function () {
            touchMoved = true;
        });
        $(document).on("click touchend", function (e) {
            // If the touchend event is detected, but the touchmoved flag is true, then don't try to close the menus
            // This is to allow users to scroll down the browser in order to navigate a long menu, without it unexpectedly closing the menu
            if (e.type == "touchend" && touchMoved)
                return;
            // Close by default
            var closePullouts = true;
            // Except when a touch or click is detected in the nav panels
            if ($(e.target).hasClass("mobile-menu") || $(e.target).parents(".mobile-menu").length > 0)
                closePullouts = false;
            if (closePullouts) {
                $(".wrapper").removeClass("reveal-right");
                if ($("#m_google_translate_element").is(":visible")) {
                    $("#google_translate_element").appendTo($("#googleTrans"));
                }
            }
        });
    }
    PageSetup.InitNavigation = InitNavigation;
    function GeolocateCouncil() {
        if (window.navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(findCouncilandLocation, function (posError) {
                handleNoGeolocation("We were unable to get your location from your browser for the following reason: <i>" + posError.message + "</i>");
            });
        }
        else {
            handleNoGeolocation("Your browser was unable to provide us with your location details.");
        }
    }
    PageSetup.GeolocateCouncil = GeolocateCouncil;
    function InitSliders() {
        // Initialise any sliders with the 'slickify' class using its defined settings
        $('.slickify').each(function () {
            $(this).not('.slick-initialized').slick({
                slidesToShow: $(this).attr("data-slick-slidesToShow"),
                slide: $(this).attr("data-slick-slideElement")
            });
        });
    }
    PageSetup.InitSliders = InitSliders;
    function InitPullout() {
        // Behaviour for the search panel pullout
        $(".pullout-button").on("click touchend", function (e) {
            e.preventDefault();
            $(this).next(".pullout-content").toggleClass("pullout-content-shown");
            $(this).toggleClass("pullout-button-active");
            var shown = $(this).next(".pullout-content").is(".pullout-content-shown");
            $(this).next(".pullout-content").attr("tabindex", shown ? "0" : "-1");
            $("#btnSupportModal").attr("tabindex", shown ? "0" : "-1");
        });
        $(".btn-support-modal").off("click touchend").on("click touched", function () {
            $("#website-help .pullout-content").removeClass("pullout-content-shown");
            $("#website-help .pullout-button").removeClass("pullout-button-active");
        });
    }
    PageSetup.InitPullout = InitPullout;
    function InitTextSizeChange() {
        $(".text-larger").on("click touchend", function (e) {
            e.preventDefault();
            var increment = 10;
            ChangeTextSize(increment);
        });
        $(".text-smaller").on("click touchend", function (e) {
            e.preventDefault();
            var increment = -10;
            ChangeTextSize(increment);
        });
        $(".textSizeIndicator").on("click touchend", function (e) {
            e.preventDefault();
            ResetTextSize();
        }).on("mouseover", function (e) {
            e.preventDefault();
            $(".textSizeIndicator").text('Reset');
        }).on("mouseout", function (e) {
            e.preventDefault();
            if (textSize === 0)
                textSize = 100;
            $(".textSizeIndicator").text(textSize + '%');
        });
        if (typeof (Storage) !== "undefined") {
            // Check for previous changes to text size
            var incrementCount = parseInt(localStorage.getItem("incrementCount")) || 0;
            var i = 0;
            if (incrementCount > 0) {
                // Increase font size until it matches previous setting
                for (i = 0; i < incrementCount; i++) {
                    ChangeTextSize(10);
                }
            }
            else if (incrementCount < 0) {
                // Decrease font size until it matches previous setting
                for (i = 0; i > incrementCount; i--) {
                    ChangeTextSize(-10);
                }
            }
        }
    }
    PageSetup.InitTextSizeChange = InitTextSizeChange;
    function ResetTextSize() {
        if (typeof (Storage) !== "undefined") {
            localStorage.setItem("incrementCount", "0");
        }
        textSize = 100;
        ChangeTextSize(0);
    }
    PageSetup.ResetTextSize = ResetTextSize;
    function SaveTextSize(size) {
        if (typeof (Storage) !== "undefined") {
            localStorage.setItem("incrementCount", (parseInt(size) || 0).toString());
        }
    }
    PageSetup.SaveTextSize = SaveTextSize;
    function ChangeTextSize(increment) {
        textSize = textSize === 0 ? (100 + increment) : (textSize + increment);
        SaveTextSize(((textSize - 100) / 10).toString());
        $(".section, .pullout-content").each(function () {
            $(this).css({ "font-size": textSize + "%" });
        });
        $(".textSizeIndicator").text(textSize + '%');
    }
    PageSetup.ChangeTextSize = ChangeTextSize;
    function ObfuscateEmails() {
        var elementsToObfuscate = $(".email-obfuscate");
        elementsToObfuscate.each(function () {
            var emailStart = $(this).data("email-start");
            var emailAt = $(this).data("email-at");
            var setText = Boolean($(this).data("set-text"));
            $(this).attr("href", "mailto:" + emailStart + "@" + emailAt);
            if (setText)
                $(this).text(emailStart + "@" + emailAt);
        });
    }
    PageSetup.ObfuscateEmails = ObfuscateEmails;
    function InitMap() {
        $(".view-toggles .btn-map").on('click touchend', function () {
            ShowCategoriesMap();
        });
        function ShowCategoriesMap() {
            var mapContainer = $("#search-map");
            // Check that the map isn't already initialised
            if (mapContainer.length !== 0 && !mapContainer[0].firstChild) {
                var location = new google.maps.LatLng(-27.4679, 153.0278);
                var MY_MAPTYPE_ID = 'custom_style';
                var mapOptions = {
                    zoom: 12,
                    center: location,
                    mapTypeControlOptions: {
                        mapTypeIds: [google.maps.MapTypeId.ROADMAP, MY_MAPTYPE_ID]
                    },
                    MapTypeId: MY_MAPTYPE_ID
                };
                window.MapView = new google.maps.Map(mapContainer[0], mapOptions);
                var styledMapOptions = { name: 'Custom Style' };
                var customMapType = new google.maps.StyledMapType(Common.Map.GetStandardMapStyle(), styledMapOptions);
                window.MapView.mapTypes.set(MY_MAPTYPE_ID, customMapType);
            }
            else {
                // If the map has already been loaded, trigger a resize event so that the map loads correctly.
                // This prevents a bug which caused the map to load incorrectly after the map had loaded then the browser size is changed.
                google.maps.event.trigger(window.MapView, 'resize');
            }
        }
    }
    PageSetup.InitMap = InitMap;
    function InitAutoComplete() {
        // This is an example of how the autocomplete functionality could be acheived using an external json file.
        // For documentation on other methods, see this page: http://twitter.github.io/typeahead.js/examples/
        var q = "";
        var categories = new Bloodhound({
            datumTokenizer: Bloodhound.tokenizers.obj.whitespace('Name'),
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            remote: {
                url: '/api/search/Services',
                replace: function (url, query) {
                    q = query;
                    // Change the url target url so it triggers
                    url = url + '#' + encodeURIComponent(q);
                    return url;
                },
                ajax: {
                    beforeSend: function (query, settings) {
                        settings.data = JSON.stringify({ SearchTerm: q });
                    },
                    dataType: 'json',
                    contentType: 'application/json; charset=utf-8',
                    type: 'POST'
                }
            }
        });
        var shiftCategories = new Bloodhound({
            datumTokenizer: Bloodhound.tokenizers.obj.whitespace('Name'),
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            limit: 5,
            remote: {
                url: '/api/search/ShiftServices',
                replace: function (url, query) {
                    q = query;
                    // Change the url target url so it triggers
                    url = url + '#' + encodeURIComponent(q);
                    return url;
                },
                ajax: {
                    beforeSend: function (query, settings) {
                        settings.data = JSON.stringify({ SearchTerm: q });
                    },
                    dataType: 'json',
                    contentType: 'application/json; charset=utf-8',
                    type: 'POST'
                }
            }
        });
        var tags = new Bloodhound({
            datumTokenizer: Bloodhound.tokenizers.obj.whitespace('DisplayText'),
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            remote: {
                url: '/api/search/tags',
                replace: function (url, query) {
                    q = query;
                    // Change the url target url so it triggers
                    url = url + '#' + encodeURIComponent(q);
                    return url;
                },
                ajax: {
                    beforeSend: function (ev, settings) {
                        settings.data = JSON.stringify(q);
                    },
                    dataType: "json",
                    contentType: 'application/json; charset=utf-8',
                    type: 'POST'
                }
            }
        });
        var orgs = new Bloodhound({
            datumTokenizer: Bloodhound.tokenizers.obj.whitespace('DisplayText'),
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            remote: {
                url: '/api/search/organisations',
                replace: function (url, query) {
                    q = query;
                    // Change the url target url so it triggers
                    url = url + '#' + encodeURIComponent(q);
                    return url;
                },
                ajax: {
                    beforeSend: function (ev, settings) {
                        settings.data = JSON.stringify({ SearchTerm: q, CouncilRegionId: $("#hfCouncilId").val() || null, State: $("#State_Code").val() || null });
                    },
                    dataType: "json",
                    contentType: 'application/json; charset=utf-8',
                    type: 'POST'
                }
            }
        });
        //var locations = McdMaps.getResults("#autocomplete-location-new");
        //var locations = null;
        var councils = new Bloodhound({
            datumTokenizer: Bloodhound.tokenizers.obj.whitespace('DisplayName'),
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            limit: 10,
            remote: {
                url: '/api/search/councils',
                ajax: {
                    beforeSend: function () { showSpinner('#autocomplete-council, #autocomplete-council-mobile'); },
                    complete: function () { removeSpinner('#autocomplete-council, #autocomplete-council-mobile'); }
                },
                replace: function (url, query) {
                    // Trailing spaces can cause routing issues with GET requests so trim them
                    return url + "/" + (query || "").trim();
                }
            }
        });
        // kicks off the loading/processing of `local` and `prefetch`
        categories.initialize();
        shiftCategories.initialize();
        //locations.initialize();
        councils.initialize();
        tags.initialize();
        orgs.initialize();
        // passing in `null` for the `options` arguments will result in the default
        // options being used
        $("#autocomplete-category").typeahead({
            hint: true,
            minLength: 2,
            highlight: true
        }, {
            name: 'categories',
            displayKey: 'Name',
            source: categories.ttAdapter(),
            templates: {
                header: "<div class='tt-suggestion-title'><h3 class='h6'>Categories</h3></div>",
                suggestion: function (d) {
                    return "<p class='needsclick'>" + d.Name + "</p>";
                }
            }
        }, {
            name: 'shiftCategories',
            displayKey: 'Name',
            source: shiftCategories.ttAdapter(),
            templates: {
                header: "<div class='tt-suggestion-title'><h3 class='h6'>Shift Categories</h3></div>",
                suggestion: function (d) {
                    return "<p class='needsclick'>" + d.Name + "</p>";
                }
            }
        }, {
            name: "tags",
            displayKey: "DisplayText",
            source: tags.ttAdapter(),
            templates: {
                header: "<div class='tt-suggestion-title'><h3 class='h6'>Tags</h3></div>",
                suggestion: function (d) {
                    return "<p class='needsclick'>" + d.TagName + ((d.TagName != d.DisplayText) ? " (<i>" + d.DisplayText + "</i>)" : "") + "</p>";
                }
            }
        }, {
            name: "organisations",
            displayKey: "DisplayText",
            source: orgs.ttAdapter(),
            templates: {
                header: "<div class='tt-suggestion-title'><h3 class='h6'>Locations</h3></div>",
                suggestion: function (d) {
                    return "<p class='needsclick'>" + d.DisplayText + "</p>";
                }
            }
        });
        var currentBatchExecutions = 0;
        var maxBatchExecutions = 3;
        $("#autocomplete-category")
            .on("typeahead:selected", function (obj, datum) {
            if (typeof datum.CategoryGroupID !== "undefined") {
                $("#hfCategoryGroupId").val(datum.CategoryGroupID);
                $("#hfCategoryId").val(datum.CategoryID);
                $("#hfShiftCategoryId").val("0");
            }
            else if (typeof datum.TagName !== "undefined") {
                $("#hfTagName").val(datum.TagName);
                $("#hfShiftCategoryId").val("0");
            }
            else if (typeof datum.IsOrganisation !== "undefined") {
                $(datum.IsOrganisation ? "#hfOrganisationId" : datum.IsLocation ? "#hfOutletId" : "#hfOSRId").val(datum.ID);
                $("#hfShiftCategoryId").val("0");
            }
            else if (typeof datum.ShiftCategoryID !== "undefined") {
                $("#hfShiftCategoryId").val(datum.ShiftCategoryID);
            }
        }).on("typeahead:autocompleted", function (obj, datum) {
            if (typeof datum.CategoryGroupID !== "undefined") {
                $("#hfCategoryGroupId").val(datum.CategoryGroupID);
                $("#hfCategoryId").val(datum.CategoryID);
            }
            else if (typeof datum.TagName !== "undefined") {
                $("#hfTagName").val(datum.TagName);
            }
            else if (typeof datum.IsOrganisation !== "undefined") {
                $(datum.IsOrganisation ? "#hfOrganisationId" : datum.IsLocation ? "#hfOutletId" : "#hfOSRId").val(datum.ID);
            }
            else if (typeof datum.ShiftCategoryID !== "undefined") {
                $("#hfShiftCategoryId").val(datum.ShiftCategoryID);
            }
        }).on("typeahead:startupdate", function () {
            currentBatchExecutions = 0;
            showSpinner("#autocomplete-category");
            $("#hfCategoryGroupId").val("0");
            $("#hfCategoryId").val("0");
            $("#hfOrganisationId").val("0");
            $("#hfOutletId").val("0");
            $("#hfOSRId").val("0");
            $("#hfTagName").val("");
            $("#hfShiftCategoryId").val("0");
        }).on("typeahead:datasetupdated", function () {
            if (++currentBatchExecutions >= maxBatchExecutions) {
                removeSpinner("#autocomplete-category");
            }
        });
        // Locations
        //locationTypeahead(".location-filter", locations);
        //locationTypeahead("#location-request", locations);
        // Councils
        $('#autocomplete-council, #autocomplete-council-mobile').typeahead({
            hint: true,
            minLength: 2,
            highlight: true
        }, {
            name: 'councils',
            displayKey: 'DisplayName',
            source: councils.ttAdapter(),
            templates: {
                suggestion: function (d) {
                    return "<p class='needsclick'>" + d.DisplayName + "</p>";
                }
            }
        });
        $('#autocomplete-council, #autocomplete-council-mobile').on('typeahead:selected', function (obj, datum, name) {
            resetSessionAdsressModel();
            window.location.href = datum.Url;
        });
        // Search On Press Enter
        $(".on-enter").on("keypress", function (e) {
            if (e.which === 13) {
                var clickTarget = $(this).data("click-target") || "btn-search";
                $("#" + clickTarget).click();
            }
        });
    }
    PageSetup.InitAutoComplete = InitAutoComplete;
    function resetSessionAdsressModel() {
        $.ajax({
            url: "/StoreSearchedModelInSession",
            type: "POST",
            contentType: "application/json",
            dataType: "json",
            data: null,
            error: function (result) {
                //console.log("fail: ", result);
            },
            success: function (result) {
                //console.log("victory")
            },
        });
    }
    function locationTypeahead(fieldName, locations) {
        $(fieldName).typeahead({
            hint: true,
            minLength: 2,
            highlight: true
        }, {
            name: "locations",
            displayKey: "Name",
            source: locations.ttAdapter(),
            templates: {
                suggestion: function (d) {
                    return "<p class='needsclick'>" + d.Name + "</p>";
                }
            }
        });
        $(fieldName)
            .on("typeahead:selected", function (obj, datum) {
            $(".locality-id", $(this).closest(".twitter-typeahead").parent()).val(datum.LocalityID);
        }).on("typeahead:autocompleted", function (obj, datum) {
            $(".locality-id", $(this).closest(".twitter-typeahead").parent()).val(datum.LocalityID);
        }).on("typeahead:asyncrequest", function () {
            $(".locality-id", $(this).closest(".twitter-typeahead").parent()).val(0);
            $(this).addClass("spinner");
        }).on("typeahead:startupdate", function () {
            $(".locality-id", $(this).closest(".twitter-typeahead").parent()).val(0);
            $(this).addClass("spinner");
        }).on("typeahead:datasetupdated", function () {
            $(this).removeClass("spinner");
            if (!$(this).val() || !$(this).val().toString().length) {
                $(".locality-id", $(this).closest(".twitter-typeahead").parent()).val(0);
            }
        });
    }
    PageSetup.locationTypeahead = locationTypeahead;
    function InitCouncilSearch() {
        $(".council-trail").on("click", ".regionfilter", function () {
            $("#councilModal").modal("show");
            $("#autocomplete-council").focus();
        });
        var hideSelector = getCookie("hide-council-selector");
        $('#setCouncilHide').prop('checked', hideSelector !== 'true');
        $("#setCouncilHide").on("click", function () {
            setCookie("hide-council-selector", !$("#setCouncilHide").is(":checked"), 365);
        });
        $("#locateMe").on("click", function (e) {
            e.preventDefault();
            //PageSetup.GeolocateCouncil();
            $("#councilModal").modal('hide');
        });
        $("#locateMee").on("click", function (e) {
            e.preventDefault();
            //PageSetup.GeolocateCouncil();
            $("#councilModal").modal('hide');
        });
        $("#getMyCouncil").on("click", function (e) {
            navigator.geolocation.getCurrentPosition(findCouncilLocation, function (posError) {
                handleNoGeolocation("We were unable to get your location from your browser for the following reason: <i>" + posError.message + "</i>");
            });
        });
        $(document).ready(function () {
            $('#autocomplete-category').keypress(function (e) {
                if (e.keyCode == 13)
                    $('#getMyCouncil').click();
            });
        });
    }
    PageSetup.InitCouncilSearch = InitCouncilSearch;
    function SendMail(to, subject, body) {
        var email = { To: to, Subject: subject, Body: body };
        $.ajax({
            type: 'POST',
            url: "/api/Email/Send",
            data: JSON.stringify(email),
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            success: function (data) { alert(data); },
            error: function () { alert('Failed'); }
        });
    }
    PageSetup.SendMail = SendMail;
    function InitSearchResultsBehavior() {
        Common.SetupTooltipsStyling();
        $("a.phone").each(function () {
            $(this).attr("href", "tel:" + $(this).data("phone")
                .replace(/ /g, "")
                .replace(/\(/g, "")
                .replace(/\)/g, ""));
        });
    }
    PageSetup.InitSearchResultsBehavior = InitSearchResultsBehavior;
    function InitSponsors(affiliateId, councilId, hideSponsors, isCommunityInfo, councilLogo, councilUrl) {
        if (!hideSponsors) {
            loadPlatformSponsors(affiliateId, councilId, isCommunityInfo, councilLogo, councilUrl);
        }
    }
    PageSetup.InitSponsors = InitSponsors;
    function SetCookie(cname, cvalue, exdays) {
        setCookie(cname, cvalue, exdays);
    }
    PageSetup.SetCookie = SetCookie;
    function GetCookie(cname) {
        return getCookie(cname);
    }
    PageSetup.GetCookie = GetCookie;
    function InitOneClick() {
        $(".one-click").closest('form').on('submit', function (e) {
            var $form = $(this);
            if ($form.data('submitted') === true) {
                // Previously submitted - don't submit again
                e.preventDefault();
            }
            else {
                // Mark it so that the next submit can be ignored
                $form.data('submitted', true);
            }
        });
    }
    PageSetup.InitOneClick = InitOneClick;
})(PageSetup || (PageSetup = {}));
